import { type UseQueryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { TeamsApi } from '@/lib/api/teams/team';
import type { TeamsResponse } from '@/lib/api/types/teams';
import { teamsQueryKeys } from '@/lib/query-keys/teams';
import { associateById } from '@/lib/utils/common/associateById';

export const getTeamsQueryOptions = () => {
  return {
    queryKey: teamsQueryKeys.all(),
    queryFn: TeamsApi.getTeams,
  };
};

export const useSuspenseGetTeamsQuery = () => {
  return useSuspenseQuery(getTeamsQueryOptions());
};

export const useGetTeamsQuery = (options: Partial<UseQueryOptions<TeamsResponse>> = {}) => {
  return useQuery({ ...getTeamsQueryOptions(), ...options });
};

export const useGetTeamsByIdQuery = (options: Partial<UseQueryOptions<TeamsResponse>> = {}) => {
  return useQuery({
    ...getTeamsQueryOptions(),
    ...options,
    select: (data) => associateById(data.items),
  });
};
